import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TicketIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Ticket",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m22.59 6.2-4.25-4.25-2.13 2.12-9.03 9.04 2.66 2.65-1.02 1.02-2.71-2.61-3.68 3.68c-.27.27-.44.65-.44 1.06s.17.79.44 1.06l9.53 9.64c.27.27.65.44 1.06.44s.79-.17 1.06-.44l.58-.58.48-.47 2.65-2.66-2.65-2.65 1.02-1.02 2.66 2.66 9.03-9.04 2.13-2.12-2.1-2.21-2.12-2.12c-.4.38-.95.62-1.55.62-1.24 0-2.25-1.01-2.25-2.25 0-.6.23-1.14.62-1.55Zm-9.04 15.37-3.19-3.19 1.02-1.02 3.19 3.19zm7.09-8.2-1.02 1.02.24 1.42v.07a.47.47 0 0 1-.68.42s-1.27-.67-1.27-.67l-1.27.67s-.1.02-.15.02-.1 0-.15-.02a.47.47 0 0 1-.39-.45v-.08l.25-1.41-1.02-1.02a.43.43 0 0 1-.13-.26s0-.05 0-.07c0-.24.17-.43.4-.47l1.41-.2.63-1.17c.04-.07.1-.13.17-.17a.5.5 0 0 1 .25-.07c.18 0 .33.1.42.24s.64 1.28.64 1.28l1.42.22c.11.01.2.06.27.13a.463.463 0 0 1-.01.63v-.06Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11.29 15.14c-.63 0-1.14-.51-1.14-1.14v-3.43a1.14 1.14 0 1 1 2.28 0V14c0 .63-.51 1.14-1.14 1.14M11.29 23.14c-.63 0-1.14-.51-1.14-1.14v-3.43a1.14 1.14 0 1 1 2.28 0V22c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M30.71 27.71H1c-.63 0-1.14-.51-1.14-1.14v-6.86c0-.63.51-1.14 1.14-1.14 1.26 0 2.29-1.03 2.29-2.29S2.26 13.99 1 13.99c-.63 0-1.14-.51-1.14-1.14V5.99c0-.63.51-1.14 1.14-1.14h29.71c.63 0 1.14.51 1.14 1.14v6.86c0 .63-.51 1.14-1.14 1.14-1.26 0-2.29 1.03-2.29 2.29a2.285 2.285 0 0 0 2.29 2.29c.61 0 1.14.51 1.14 1.14v6.86c0 .63-.51 1.14-1.14 1.14M2.14 25.43h27.43v-4.72a4.58 4.58 0 0 1-3.43-4.43c0-2.13 1.46-3.92 3.43-4.43V7.13H2.14v4.72c1.97.51 3.43 2.3 3.43 4.43s-1.46 3.92-3.43 4.43z"
      })]
    })
  }));
};
TicketIcon.displayName = 'TicketIcon';